import { FormattedAddress } from '../services/location.service';
import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { Customer } from './customer.class';
import { Dayreport } from './dayreport.class';
import { Material } from './material.class';
import { PlanningFile } from './planning-file';
import { PlanningHasEntity } from './planning-has-entity.class';
import { PlanningMaterial } from './planning-material.class';
import { PlanningRepetition } from './planning-repetition';
import { PlanningAsfaltteam } from './planningasfaltteam.class';
import { PlanningAsphalt } from './planningasphalt.class';
import { PlanningCutter } from './planningcutter.class';
import { PlanningDumper } from './planningdumper.class';
import { PlanningHirePeople } from './planninghirepeople.class';
import { PlanningPreparationteam } from './planningpreparationteam.class';
import { PlanningProjectteam } from './planningprojectteam.class';
import { PlanningSet } from './planningset.class';
import { Project } from './project.class';
import { Status } from './status.class';
import { UserPlanning } from './user-planning';
import { User } from './user.class';

export class Planning implements RealtimeInterface {
    id: number;
    planning_has_id: number;
    mainPlanning?: PlanningHasEntity;
    user_id: number;
    status_key: string;
    performer: number;
    performer_user: User;
    contractor: string;
    afas_customer_id?: string;
    worknumber: string;
    projectmanager: number;
    projectmanager_user: User;
    location: string;
    location_data: FormattedAddress;
    customer?: Customer;
    asphalt_location: string;
    trucks: any;
    traffic_controllers: any;
    mobile_crane: any;
    scatter: boolean;
    sticky_wagon: string;
    description: string;
    created_at: Date;
    updated_at: Date;
    traffic: string;
    pouring_off: string;
    tokband: any;
    hotbox: boolean;
    asphalt_performer: number;
    asphalt_performer_user: User;
    user: User;
    status: Status;
    planning_sets: PlanningSet[];
    planning_trucks: PlanningHasEntity[];
    planning_dumpers: PlanningDumper[];
    planning_cranes: PlanningHasEntity[];
    planning_sticky_wagons: PlanningHasEntity[];
    planning_asphalt_others: PlanningHasEntity[];
    planning_vkm: PlanningHasEntity[];
    planning_rollers: PlanningHasEntity[];
    planning_cutters: PlanningCutter[];
    planning_wipetrucks: PlanningHasEntity[];
    planning_asfaltteam: PlanningAsfaltteam;
    planning_preparationteam: PlanningPreparationteam;
    planning_projectteam: PlanningProjectteam;
    planning_has: PlanningHasEntity[];
    planning_has_all: PlanningHasEntity[];
    asphalt_list: PlanningAsphalt[];
    planning_hire_people: PlanningHirePeople[];
    user_planning: UserPlanning[];
    materials: Material[];
    planning_materials: PlanningMaterial[];
    planning_files: PlanningFile[];
    dagrapporten?: Dayreport[];

    is_transport: boolean;
    afas_project_id?: string;
    project: Project;
    comment: string;

    leave_id?: number;
    resident_letter?: string;
    planning_repetition_id?: number;
    planning_repetition?: PlanningRepetition;

    data?: any;

    deleted?: boolean; //used by websockets
    deleted_at?: Date | null;
    valid?: boolean | null;
}

export enum PlanningSize {
    Hotbox = 'hotbox',
    Middel = 'middel',
    Groot = 'groot',
}
